import { CihSectionHeader } from "~/components/cih/section-header";
import { MarkdownContent } from "~/components/markdown-content";
import { CDNImage } from "~/components/ui/cdn-image";

type Props = {
  firstName: string;
  description: string | null;
  /**
   * Coach avatar (square, e.g. `coach.profilePictureUrl`). Rendered as a
   * circle so coaches don't have to maintain a separate portrait crop.
   */
  avatarUrl: string | null;
  sectionNumber: number;
};

export function CoachAboutSection({
  firstName,
  description,
  avatarUrl,
  sectionNumber,
}: Props) {
  if (!description?.trim()) return null;

  return (
    <section id="about" className="border-t border-gray-200">
      <CihSectionHeader
        label={`${String(sectionNumber).padStart(2, "0")} · About`}
        title={`About ${firstName}`}
      />
      <div className="mx-auto max-w-7xl px-4 pb-14 md:pb-20 xl:px-0">
        <div
          className={
            avatarUrl
              ? "flex flex-col gap-8 md:flex-row md:items-start md:gap-12"
              : ""
          }
        >
          {avatarUrl && (
            <div className="flex justify-center md:shrink-0 md:justify-start">
              <CDNImage
                src={avatarUrl}
                alt=""
                width={400}
                height={400}
                className="size-40 rounded-full border border-gray-100 object-cover shadow-md ring-1 ring-gray-900/5 md:size-48"
              />
            </div>
          )}
          <div className="prose-coach max-w-prose text-gray-700">
            <MarkdownContent ugc content={description} />
          </div>
        </div>
      </div>
    </section>
  );
}
